

function Blog() {
  return (
  <section className="blog_section section_space bg-light" style={{backgroundImage: 'url("/assets/images/shapes/bg_pattern_1.svg")'}}>
  <div className="container">
    <div className="heading_block text-center">
      <div className="heading_focus_text">
        <span className="badge bg-secondary text-white">Blog</span> 
        Updates
      </div>
      <h2 className="heading_text mb-0">
        Latest Articles Posts
      </h2>
    </div>
    <div className="row">
      <div className="col-lg-4">
        <div className="blog_post_block">
          <div className="blog_post_image">
      <a className="image_wrap" href="/blog">
        <img src="/assets/images/blog/custom-support.jpg" loading="lazy" alt="Blog Post Image 1" />
            </a>
          </div>
          <div className="blog_post_content">
            <div className="post_meta_wrap">
              <ul className="category_btns_group unordered_list">
                <li>Branding</li>
                <li>UI/UX</li>
              </ul>
              <ul className="post_meta unordered_list">
                {/* <li>
                  <img src="/assets/images/icons/icon_calendar.svg" loading="lazy" alt="Icon Calendar" /> 11/12/2024
                </li>
                <li>
                  <i className="fa-regular fa-comment-lines" /> 24
                </li> */}
              </ul>
            </div>
            <h3 className="blog_post_title">
              <a href="/blog">
                Services offered in Customer Support
              </a>
            </h3>
            <a className="btn_unfill" href="/blog">
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right" />
              </span>
              <span className="btn_label">Read More</span>
            </a>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="blog_post_block">
          <div className="blog_post_image">
      <a className="image_wrap" href="/blog">
        <img src="/assets/images/blog/admin-support-service.jpg" loading="lazy" alt="Blog Post Image 2" />
            </a>
          </div>
          <div className="blog_post_content">
            <div className="post_meta_wrap">
              <ul className="category_btns_group unordered_list">
                <li>Mobile App</li>
              </ul>
              <ul className="post_meta unordered_list">
                {/* <li>
                  <img src="/assets/images/icons/icon_calendar.svg" loading="lazy" alt="Icon Calendar" /> 11/12/2024
                </li>
                <li>
                  <i className="fa-regular fa-comment-lines" /> 24
                </li> */}
              </ul>
            </div>
            <h3 className="blog_post_title">
              <a href="/blog">
                A Review of Trustworthy Admin Support Service
              </a>
            </h3>
            <a className="btn_unfill" href="/blog">
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right" />
              </span>
              <span className="btn_label">Read More</span>
            </a>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="blog_post_block">
          <div className="blog_post_image">
      <a className="image_wrap" href="/blog">
        <img src="/assets/images/blog/virtual-assistants-work-desk-setup.jpg" loading="lazy" alt="Blog Post Image 3" />
            </a>
          </div>
          <div className="blog_post_content">
            <div className="post_meta_wrap">
              <ul className="category_btns_group unordered_list">
                <li>Technology</li>
              </ul>
              <ul className="post_meta unordered_list">
                {/* <li>
                  <img src="/assets/images/icons/icon_calendar.svg" loading="lazy" alt="Icon Calendar" /> 11/12/2024
                </li>
                <li>
                  <i className="fa-regular fa-comment-lines" /> 24
                </li> */}
              </ul>
            </div>
            <h3 className="blog_post_title">
              <a href="/blog">
                A Look at a Virtual Assistant's WorkDesk Setup
              </a>
            </h3>
            <a className="btn_unfill" href="/blog">
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right" />
              </span>
              <span className="btn_label">Read More</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  );
}

export default Blog;
